import containerisedAppImg from "../assets/containerised-app.svg";
import openstackImg from "../assets/openstack.svg";
import standaloneApp from "../assets/standalone-app.svg";
import type { IProductListDetails } from "../constants/apiconstants-pyxis";
import { ProductListingTypes } from "../constants/products";

const MAX_SCORE_LIST = 10;

export const getTypeNameWithIcon = (type: string) => {
	switch (type) {
		case ProductListingTypes.ContainerStack:
			return <img src={containerisedAppImg} alt={"Container-Application-icon"} />;
		case ProductListingTypes.TraditionalApplication:
			return <img src={standaloneApp} alt={"Standalone-Application-icon"} />;
		case ProductListingTypes.OpenStackInfrastructure:
			return <img src={openstackImg} alt={"Openstack-infrastructure-icon"} />;
		default:
			return null;
	}
};

export const calculateLocalProductScore = (productDetails: IProductListDetails) => {
	const MAX_LOCAL_SCORE = MAX_SCORE_LIST + 1.1;
	let scoreList = 0;
	let scoreCert = 0;

	if (productDetails?.name) ++scoreList;
	if (productDetails?.descriptions?.short) ++scoreList;
	if (productDetails?.descriptions?.long) ++scoreList;
	if ((productDetails?.contacts ?? []).length > 0) ++scoreList;
	scoreList = scoreList + Math.min(3, productDetails?.linked_resources?.length || 0);
	if (productDetails?.support?.url) ++scoreList;
	if ((productDetails?.functional_categories ?? []).length > 0) ++scoreList;
	if ((productDetails?.search_aliases ?? []).length > 0) ++scoreList;

	if (productDetails?.product_validations_data?.validations?.length > 0) ++scoreCert;
	else if ((productDetails?.cert_projects ?? []).length > 0) ++scoreCert;

	return {
		productScorePercentage: Math.floor(((scoreList + scoreCert) / MAX_LOCAL_SCORE) * 100),
		scoreCert,
		scoreList,
	};
};
